<template>
  <div class="myCommission-warpper">
    <nav-bar titleText="可提现金额" titleWeight="bold" @goBack="goBack" :isFixed="true"></nav-bar>
    <div class="contentBox">
      <div class="current_commission">
        <p class="current">我的可提现金额</p>
        <p class="current_money">
          <span>¥</span>
          {{balance}}
        </p>
        <div class="withdrawal">
          <van-button type="primary" @click="handleWithdrawal()" class="withdrawal_btn">提现</van-button>
        </div>
      </div>
      <p class="subsidiary">
        <span>明细</span>
        <span class="refresh-btn" @click="refreshList">
          <img :src="reloadgrayicon" alt="">
        </span>
      </p>
      <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :style="styleRefresh"> -->
        <van-list v-model="loading" :finished="finished" :finished-text="this.list.length === 0 ? '' : '没有更多了'"
          @load="onLoad">
          <van-cell class="subsidiary_list" v-for="(item, index) in list" :key="index">
            <div class="subsidiary_content" @click="handleDetail(item)">
              <van-row class="subsidiary_row">
                <van-col class="order_income" span="10">{{odertitle(item.type)}}</van-col>
                <van-col class="order_time" span="14">{{item.created_at}}</van-col>
              </van-row>
              <p class="order_money">
                {{item.change_amount && item.change_amount.toString().indexOf("-") === -1 ? '+' : ''}}{{item.change_amount}}
              </p>
              <p class="order_remark">{{item.remark}}</p>
            </div>
          </van-cell>
        </van-list>
        <div class="empty" ref="commissionEmpty" v-if="list.length == 0" :style="{'padding-bottom': paddingBottom}">
          <div class="emptyMsg" span="24">
            <img src="../../../assets/debtor/empty.png" width="100%" height="100%" />
            <p class="tip">暂无数据</p>
          </div>
        </div>
      <!-- </van-pull-refresh> -->

      <!-- 暂无数据 -->
    </div>
    <van-popup v-model="show">
      <div class="commission-box">
        <img src="../../../assets/common/BG@2x.png" alt="" />
        <p class="title">温馨提示</p>
        <p class="tips">提现业务维护中，详询客服!</p>
        <span @click="show = false">好的</span>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import navBar from "../components/navBar";
  export default {
    name: "myCommission",
    data() {
      return {
        list: [],
        commissionData: {},
        loading: false,
        finished: false,
        refreshing: false,
        error: false,
        page: 0,
        pageSize: 10,
        paddingBottom: '',
        includeDetail: {},
        styleRefresh: {
          'min-height': document.body.clientHeight - 330 + 'px'
        },
        show: false,
        balance: '',
        reloadgrayicon: require('@/assets/debt/reload-gray-icon.png'),
      };
    },
    created() {
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token);
      }
      // this.commissionInfo();
    },
    mounted() {
      this.getPaddingBottom()
    },
    components: {
      navBar,
    },
    methods: {
      getPaddingBottom() {
        const rect = this.$refs.commissionEmpty.getBoundingClientRect()
        this.paddingBottom = document.body.clientHeight - (rect.top + rect.height) - 103 + 'px'
      },
      onLoad() {
        this.page++;
        this.getInfo();
        // setTimeout(() => {
        //   this.page++;
        //   this.getInfo();
        //   // 加载状态结束
        //   // this.loading = false;
        // }, 500);
      },
      refreshList() {
        if (!this.refreshing) {
          this.refreshing = true
          this.page = 0;
          this.onLoad();
        }
      },
      // onRefresh() {
      //   this.page = 0;
      //   this.onLoad();
      // },
      odertitle(type) {
        switch (type) {
          case -1:
            return '提现'
          case 1:
            return '解债订单收入'
          case 2:
            return '津贴收入'
          case 3:
            return '提现驳回退款'
        }
      },
      getInfo() {
        // TODO 这个列表接口不对()
        this.$api
          .post("/debt/member/withdrawal/withdrawal/log", {
            pageNum: this.page,
            pageSize: this.pageSize,
            // accountId: this.$route.query.account_id,
            // accountId: 4638656,
          })
          .then((res) => {
            this.balance = Number(res.balance).toFixed(2)
            if (res.total === 0 || res.list.length === 0) {
              this.finished = true;
              this.loading = false;
              this.refreshing = false; // 解决空列表下拉一直加载中问题
              return;
            }
            if (this.refreshing) {
              this.list = [];
              this.finished = false;
            }
            const data = res.list;
            for (let i in data) {
              this.list.push(data[i]);
            }
            this.loading = false;
            if (res.current_page === res.last_page) {
              // 数据全部加载完成
              this.finished = true;
            }
            if (this.refreshing) {
              this.$toast("刷新成功");
              this.refreshing = false;
            }
            if (!this.finished && !this.loading && this.list.length <= 5) {
              this.onLoad();
            }
          })
          .catch((err) => {
            this.finished = true
            this.loading = false;
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {}
            return;
          });
      },
      //查看当前佣金
      commissionInfo() {
        this.$api
          .post("/finance/member/account/info", {
            // 经纪人账户id
            id: this.$route.query.account_id,
            // id: 11,
          })
          .then((res) => {
            this.commissionData = res;

          })
          .catch((err) => {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {}
            return;
          });
      },
      handleWithdrawal() {
        // TODO:要求提现功能后放开
        this.$router.push({
          path: "/agent/commissionWithdrawal",
          query: {
            id: this.$route.query.account_id
          },
        });
        // this.show = true
      },
      //订单详情
      handleDetail(item) {

        // if (item.transactionType == 8) {
        //   this.$router.push({
        //     path: '/agent/commissionIncludeDetail',
        //     query: {
        //       commissionInfo: item,
        //     }
        //   })
        //   return
        // }
        if (item.type == -1) {
          this.$router.push({
            path: '/agent/withdrawalProcess',
            query: {
              id: item.order_id,
            }
          })
          return
        }
        this.$toast("暂无详情！")

      },
      goBack() {
        if (this.$route.query.debt_from === 'commissonResult') {
          this.$router.push({
            path: '/agent/agentView',
          })
          return
        }
        if (this.$route.query.type === "1") {
          this.$router.push({
            path: '/agent/agentView',
          })
          return
        }
        this.$router.go(-1);
      },
    },
  };
</script>
<style lang="less">
  .myCommission-warpper {
    background-color: #f5f6f7;
    padding-top: 88px;
    color: #333;
    min-height: calc(100vh - 88px);

    .contentBox {
      .current_commission {
        margin: 12px 12px 18px;
        background: #fff;
        border-radius: 10px;
        text-align: center;
        padding: 24px 21px;

        .current {
          font-size: 13px;
          line-height: 21px;
        }

        .current_money {
          font-weight: 600;
          font-size: 36px;
          line-height: 50px;

          span {
            font-size: 28px;
          }
        }

        .withdrawal {
          margin-top: 18px;
        }

        .withdrawal_btn {
          width: 100%;
          margin: 0 auto;
          height: 50px;
          font-size: 17px;
          display: block;
          border-radius: 30px;
          line-height: 50px;
          font-weight: 600;
          background: #fc740c;
          border: none;
        }
      }

      .subsidiary {
        margin: 6px 12px;
        font-size: 14px;
        color: #999;
        position: relative;

        .refresh-btn {
          position: absolute;
          right: 12px;
          bottom: 2px;
          width: 24px;
          height: 24px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .subsidiary_content {
        padding: 15px 18px;
        margin: 0 12px 12px;
        background: #fff;
        border-radius: 6px;
      }

      .order_income {
        font-size: 15px;
        line-height: 24px;
      }

      .order_time {
        font-size: 14px;
        color: #999;
        line-height: 23px;
        text-align: right;
      }

      .order_money {
        font-size: 24px;
        font-weight: 400;
        line-height: 32px;
      }

      .order_remark {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #999;
        line-height: 20px;
      }

      .empty {
        margin: 64px 48px 0;

        .emptyMsg {
          text-align: center;
          width: 100%;
          height: 100%;

          // img {
          //   // width: 106px;
          //   // display: inline-block;
          // }
          .tip {
            color: #999;
            font-size: 16px;
            margin-top: 15px;
          }
        }
      }

      .van-cell {
        padding: 0;
        line-height: normal;
        background-color: transparent;
      }
    }

    .van-popup--center {
      width: 70%;
      border-radius: 10px;

      .commission-box {
        img {
          display: block;
          width: 100%;
        }

        .title {
          color: #333;
          font-size: 15px;
          font-weight: 600;
          line-height: 47px;
          margin-top: 8px;
          text-align: center;
        }

        .tips {
          color: #333;
          font-size: 13px;
          line-height: 18px;
          text-align: center;
          margin-bottom: 30px;
        }

        span {
          width: 100%;
          border-top: solid 1px #F2F2F2;
          line-height: 43px;
          color: #E6212F;
          font-size: 14px;
          text-align: center;
          display: inline-block;
        }
      }
    }

  }
</style>